import { FC, PropsWithChildren } from 'react';
import { cn } from '@/shared/lib/utils';
import { useChatMessageContext } from '../model/context';

type Props = {
  className?: string;
};

/**
 * Компонент для отображения контента сообщения
 */
export const ChatMessageContent: FC<PropsWithChildren<Props>> = ({ children, className }) => {
  const { side } = useChatMessageContext();
  const isRightSide = side === 'right';

  return (
    <div
      className={cn(
        'flex flex-col gap-1.5 relative shrink-0 max-w-full font-light',
        isRightSide ? 'items-end' : 'items-start',
        className,
      )}
    >
      <div className={cn('flex gap-2 w-full text-xs')}>{children}</div>
    </div>
  );
};
